import React, { Component } from 'react';
import { Drawer, Layout, Popover } from 'antd';
import { router } from 'dva';

import CustomScrollbars from '@src/util/CustomScrollbars';
import languageData from './languageData';
import Auxiliary from '@src/util/Auxiliary';

import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  TAB_SIZE,
} from '../../constants/ThemeSetting';
import { connect } from 'dva';
import { StoreState } from '@src/interfaces';

interface TopbarProps {
  dispatch?: any;
  locale?: any;
  width?: any;
  navCollapsed?: any;
  navStyle?: any;
  themeType?: any;
}
const { Link } = router;
const { Header } = Layout;

class Topbar extends Component<TopbarProps> {
  state = {
    searchText: '',
  };

  languageMenu = () => (
    <CustomScrollbars className='gx-popover-lang-scroll'>
      <ul className='gx-sub-popover'>
        {languageData.map((language) => (
          <li
            className='gx-media gx-pointer'
            key={JSON.stringify(language)}
            onClick={() =>
              this.props.dispatch({
                type: 'settings/switchLanguage',
                payload: language,
              })
            }
          >
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className='gx-language-text'>{language.name}</span>
          </li>
        ))}
      </ul>
    </CustomScrollbars>
  );

  updateSearchChatUser = (evt: any) => {
    this.setState({
      searchText: evt.target.value,
    });
  };

  render() {
    // const { locale, width, navCollapsed, navStyle } = this.props
    const { width, navCollapsed, navStyle, themeType } = this.props;
    return (
      <Auxiliary>
        <Header>
          {navStyle === NAV_STYLE_DRAWER ||
          ((navStyle === NAV_STYLE_FIXED ||
            navStyle === NAV_STYLE_MINI_SIDEBAR) &&
            width < TAB_SIZE) ? (
            <div className='gx-linebar gx-mr-3'>
              <i
                className='gx-icon-btn icon icon-menu'
                onClick={() => {
                  this.props.dispatch({
                    type: 'settings/toggleCollapsedNav',
                    payload: !navCollapsed,
                  });
                }}
              />
            </div>
          ) : null}
          <Link to='/' className='gx-d-block gx-d-lg-none gx-pointer'>
            <img alt='' src={require('@src/assets/images/hhvn2024-logo.png')} />
          </Link>
        </Header>
      </Auxiliary>
    );
  }
}

const mapStateToProps = ({ settings }: StoreState) => {
  const { locale, navStyle, navCollapsed, width } = settings;
  return { locale, navStyle, navCollapsed, width };
};

export default connect(mapStateToProps)(Topbar);
